export default __webpack_public_path__ + "static/media/store_svg13.c17b9c82.svg";